export default angular
  .module('app.holding.dashboard.bars')
  .filter('holdingProductMetal', holdingProductMetal)
  .name;

function holdingProductMetal() {
  'ngInject';

  return productName;

  function productName(input) {
    switch (input) {
      case 'GOLD_GDB':
      case 'GOLD_1KG':
      case 'GOLD_100G':
        return 'Gold';
      case 'SILVER_GDB':
        return 'Silver';
      case 'SILVER_1KG':
        return 'Silver';
      case 'PLATINUM_GDB':
        return 'Platinum';
      case 'PALLADIUM_GDB':
        return 'Palladium';
      default:
        return undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bars/filters/product-metal.js